(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__kitAccessoryNoLink) return;
    window.__kitAccessoryNoLink = true;

    // Stop accessory titles from navigating away (covers keyboard Enter too).
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('.product-kit-line__title-link');
      if (link && link.closest('[data-kit-nolink]')) event.preventDefault();
    }, true);

    // Clicking an accessory's image or title scrolls its Add button into
    // view and gives it a quick pulse, so shoppers see where to click.
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.closest) return;
      var hit = target.closest('.product-kit-line__media, .product-kit-line__title');
      if (!hit || !hit.closest('[data-kit-nolink]')) return;
      var line = hit.closest('[data-product-kit-line]');
      var atc = line && line.querySelector('.product-kit-line__atc');
      if (!atc) return;
      atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      atc.classList.remove('kit-atc-attention');
      void atc.offsetWidth; // restart the animation
      atc.classList.add('kit-atc-attention');
      setTimeout(function () { atc.classList.remove('kit-atc-attention'); }, 2000);
    });

    // Phones: position dots under each swipeable accessory row.
    function setupCarousels() {
      document.querySelectorAll('[data-kit-mobile-carousel] .accordion .details-content').forEach(function (track) {
        var cards = track.querySelectorAll(':scope > .product-kit-line');
        if (cards.length < 2 || track.__kitDots) return;
        track.__kitDots = true;

        var dots = document.createElement('div');
        dots.className = 'kit-carousel-dots';
        dots.setAttribute('role', 'group');
        dots.setAttribute('aria-label', 'Accessories');
        cards.forEach(function (card, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Show accessory ' + (i + 1) + ' of ' + cards.length);
          dot.addEventListener('click', function () {
            var offset = card.getBoundingClientRect().left - track.getBoundingClientRect().left;
            var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
            track.scrollTo({ left: track.scrollLeft + offset - pad, behavior: 'smooth' });
          });
          dots.appendChild(dot);
        });
        track.insertAdjacentElement('afterend', dots);

        function update() {
          var trackLeft = track.getBoundingClientRect().left;
          var best = 0, bestDist = Infinity;
          cards.forEach(function (card, i) {
            var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (dist < bestDist) { bestDist = dist; best = i; }
          });
          Array.prototype.forEach.call(dots.children, function (dot, i) {
            dot.setAttribute('aria-current', i === best ? 'true' : 'false');
          });
        }
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () { ticking = false; update(); });
        }, { passive: true });
        update();
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupCarousels);
    } else {
      setupCarousels();
    }
    document.addEventListener('shopify:section:load', setupCarousels);

    // Phones: when a shopper opens Recommended Accessories or one of its
    // groups, collapse the sticky Hardware Kit summary if it's expanded,
    // then scroll so the opened panel sits just below the site header.
    var kitLastTap = { el: null, at: 0 };
    document.addEventListener('click', function (event) {
      var summary = event.target.closest && event.target.closest('[data-kit-mobile-scroll] summary');
      if (summary) kitLastTap = { el: summary.closest('details'), at: Date.now() };
    }, true);

    function kitWaitForLayout(el) {
      // Resolves once the element stops moving (panels above may be closing).
      return new Promise(function (resolve) {
        var lastTop = el.getBoundingClientRect().top, still = 0, frames = 0;
        (function check() {
          frames++;
          var top = el.getBoundingClientRect().top;
          still = Math.abs(top - lastTop) < 0.5 ? still + 1 : 0;
          lastTop = top;
          if (still >= 4 || frames >= 60) resolve();
          else requestAnimationFrame(check);
        })();
      });
    }

    function kitCollapseSummary() {
      if (!window.Alpine) return false;
      var collapsed = false;
      document.querySelectorAll('.product-kit-summary__header-row').forEach(function (row) {
        try {
          var data = window.Alpine.$data(row);
          if (data && data.mobileExpanded) {
            data.mobileExpanded = false;
            collapsed = true;
          }
        } catch (e) {}
      });
      return collapsed;
    }

    document.addEventListener('toggle', function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open) return;
      if (!details.closest('[data-kit-mobile-scroll]')) return;
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      // Only for panels the shopper just tapped, not ones opened on page load.
      if (kitLastTap.el !== details || Date.now() - kitLastTap.at > 1500) return;

      var collapsed = kitCollapseSummary();
      // Give the summary's 0.3s collapse a head start before measuring.
      var delay = collapsed ? 320 : 0;

      setTimeout(function () {
        kitWaitForLayout(details).then(function () {
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
          var y = details.getBoundingClientRect().top + window.scrollY - header - 10;
          window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      }, delay);
    }, true);

    // Take the links out of the Tab order so keyboard users skip them.
    function untab() {
      document.querySelectorAll('[data-kit-nolink] .product-kit-line__title-link').forEach(function (link) {
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-disabled', 'true');
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', untab);
    } else {
      untab();
    }
    document.addEventListener('shopify:section:load', untab);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-kit-line-universal"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productKitLineFinishSync) return;
    window.__productKitLineFinishSync = true;

    /* ---------- Filename matching ----------
       The step product and the kit product are different products, so the
       same photo has a different media ID on each. We match on filename
       instead. "strict" only removes the CDN query string, extension and
       legacy size suffix; "loose" also removes the suffixes Shopify adds when
       the same file is uploaded twice (_1, _2 or _<uuid>). */
    function baseName(url) {
      if (!url) return '';
      var file = String(url).split('?')[0].split('#')[0];
      file = file.substring(file.lastIndexOf('/') + 1);
      try { file = decodeURIComponent(file); } catch (e) {}
      file = file.toLowerCase().replace(/\.(jpe?g|png|gif|webp|avif|heic)$/, '');
      file = file.replace(/_(\d+x\d*|x\d+)(@\dx)?$/, '');
      file = file.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)$/, '');
      return file;
    }

    function strictKey(url) {
      return baseName(url);
    }

    function looseKey(url) {
      return baseName(url)
        .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '')
        .replace(/_\d{1,2}$/, '');
    }

    /* ---------- Main gallery helpers ---------- */
    function findGallery(line) {
      var section = line.closest('.shopify-section');
      return (section && section.querySelector('media-gallery')) || document.querySelector('media-gallery');
    }

    function getSlides(gallery) {
      var slides = gallery.querySelectorAll('slideshow-slide');
      if (!slides.length) slides = gallery.querySelectorAll('.product-media-container');
      return Array.prototype.slice.call(slides);
    }

    function slideUrls(slide) {
      var img = slide.querySelector('img');
      if (!img) return [];
      var urls = [img.getAttribute('src'), img.currentSrc];
      var srcset = img.getAttribute('srcset');
      if (srcset) urls.push(srcset.split(',')[0].trim().split(' ')[0]);
      return urls.filter(Boolean);
    }

    function findSlideIndex(slides, url, keyFn) {
      var target = keyFn(url);
      if (!target) return -1;
      for (var i = 0; i < slides.length; i++) {
        var urls = slideUrls(slides[i]);
        for (var j = 0; j < urls.length; j++) {
          if (keyFn(urls[j]) === target) return i;
        }
      }
      return -1;
    }

    function goToSlide(gallery, slides, index) {
      var slideshow = gallery.querySelector('slideshow-component');
      if (slideshow && typeof slideshow.select === 'function') {
        try {
          slideshow.select(index);
          return;
        } catch (e) {}
      }
      // Fallback: click the matching thumbnail if the slideshow API isn't there.
      var thumbs = gallery.querySelectorAll('slideshow-controls button');
      if (thumbs[index]) {
        thumbs[index].click();
        return;
      }
      // Grid layout (no slideshow): leave the page scroll alone.
    }

    /* ---------- Read the step's current image ---------- */
    function getLineImageUrl(line) {
      var img = null;
      var imgs = line.querySelectorAll('.product-kit-line__image');
      for (var i = 0; i < imgs.length; i++) {
        // Ignore images that belong to a nested kit line.
        if (imgs[i].closest('[data-product-kit-line]') === line) {
          img = imgs[i];
          break;
        }
      }
      var url = img ? img.getAttribute('src') : '';
      if (!url && window.Alpine && typeof window.Alpine.$data === 'function') {
        try { url = window.Alpine.$data(line).displayImageSrc || ''; } catch (e) {}
      }
      return url;
    }

    function syncGalleryFromLine(line) {
      var url = getLineImageUrl(line);
      if (!url) return;
      var gallery = findGallery(line);
      if (!gallery) return;
      var slides = getSlides(gallery);
      if (!slides.length) return;

      var index = findSlideIndex(slides, url, strictKey);
      if (index === -1) index = findSlideIndex(slides, url, looseKey);
      if (index === -1) return;

      goToSlide(gallery, slides, index);
    }

    /* ---------- Is the changed dropdown a "finish" option? ---------- */
    function isFinishSelect(select, line) {
      var label = select.closest('.product-kit-line__variant-label');
      var nameEl = label && label.querySelector('.product-kit-line__variant-name');
      var optionName = (nameEl ? nameEl.textContent : '').trim().toLowerCase();
      if (!optionName) return false;
      var names = (line.getAttribute('data-finish-option-names') || 'Finish')
        .toLowerCase()
        .split(',')
        .map(function (n) { return n.trim(); })
        .filter(Boolean);
      return names.some(function (n) { return optionName.indexOf(n) !== -1; });
    }

    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select || !select.matches || !select.matches('.product-kit-line__variant-select')) return;
      var line = select.closest('[data-product-kit-line]');
      if (!line || line.getAttribute('data-sync-gallery-finish') !== 'true') return;
      if (!isFinishSelect(select, line)) return;

      // Let Alpine finish updating the step image before reading it.
      setTimeout(function () { syncGalleryFromLine(line); }, 60);
    });
  })();

  /* ---------- Remember kit selections between visits ----------
     Saves each kit line's dropdowns, quantity and "in kit" state for this
     page in localStorage, and puts them back when the shopper returns.
     Restoring works by setting each dropdown and firing a normal change
     event, so the line's own code updates the price and the kit summary. */
  (function () {
    if (window.__productKitLineRemember) return;
    window.__productKitLineRemember = true;

    var STORAGE_KEY = 'kitState:' + location.pathname;
    var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // forget after 30 days
    var restoring = false;
    var saveTimer = null;

    function lines() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-product-kit-line][data-block-id]'));
    }

    function dataFor(el) {
      try { return window.Alpine && window.Alpine.$data(el); } catch (e) { return null; }
    }

    function load() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var state = JSON.parse(raw);
        if (!state || !state.lines || Date.now() - (state.savedAt || 0) > MAX_AGE_MS) return null;
        return state;
      } catch (e) { return null; }
    }

    function snapshot() {
      if (restoring) return;
      var out = { savedAt: Date.now(), lines: {} };
      lines().forEach(function (el) {
        var d = dataFor(el);
        var entry = { selects: {} };
        el.querySelectorAll('select.product-kit-line__variant-select[id]').forEach(function (select) {
          entry.selects[select.id] = select.value;
        });
        if (d) {
          if (typeof d.quantity === 'number') entry.qty = d.quantity;
          if (typeof d.selected === 'boolean') entry.selected = d.selected;
        }
        out.lines[el.getAttribute('data-block-id')] = entry;
      });
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(out)); } catch (e) {}
    }

    function scheduleSave() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(snapshot, 150);
    }

    function setSelect(select, value) {
      if (select.value === value) return false;
      var exists = Array.prototype.some.call(select.options, function (o) { return o.value === value; });
      if (!exists) return false;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    function restoreLine(el, entry) {
      var d = dataFor(el);
      if (!d || !entry) return Promise.resolve();

      // A ?variant= link to the main product wins over the saved choice.
      var urlHasVariant = /[?&]variant=/.test(location.search);
      var isMainProduct = el.getAttribute('data-product-id') && window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product &&
        String(window.ShopifyAnalytics.meta.product.id) === el.getAttribute('data-product-id');
      var skipSelects = urlHasVariant && isMainProduct;

      var selects = entry.selects || {};
      var productSelect = el.querySelector('select[id^="ProductKitLineProduct-"]');

      return Promise.resolve()
        .then(function () {
          // Product picker first, since it decides which option dropdowns apply.
          if (!skipSelects && productSelect && selects[productSelect.id] != null) {
            if (setSelect(productSelect, selects[productSelect.id])) return wait(60);
          }
        })
        .then(function () {
          if (skipSelects) return;
          var changed = false;
          el.querySelectorAll('select.product-kit-line__variant-select[id]').forEach(function (select) {
            if (select === productSelect) return;
            if (selects[select.id] != null && setSelect(select, selects[select.id])) changed = true;
          });
          if (changed) return wait(60);
        })
        .then(function () {
          if (typeof entry.qty === 'number' && entry.qty !== d.quantity) {
            var input = el.querySelector('.product-kit-line__quantity-input');
            var qty = Math.max(d.minQuantity || 1, Math.min(entry.qty, d.maxQuantity || entry.qty));
            if (input) {
              input.value = qty;
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              d.quantity = qty;
            }
          }
        })
        .then(function () {
          // Accessories that were in the kit go back in (no "Added" flash).
          // The kit summary and the line's price can take a moment to be
          // ready after the page loads, so keep checking for up to 3 seconds.
          if (typeof entry.selected !== 'boolean') return;
          var tries = 0;
          return new Promise(function (resolve) {
            (function attempt() {
              if (d.selected === entry.selected) return resolve();
              var atc = el.querySelector('.product-kit-line__atc');
              if (d.summaryMode && atc && !atc.disabled) {
                atc.click();
                clearTimeout(d.kitTimer);
                d.kitFlash = false;
                return resolve();
              }
              if (++tries >= 30) return resolve();
              setTimeout(attempt, 100);
            })();
          });
        });
    }

    function restoreAll() {
      var state = load();
      if (!state) return;
      restoring = true;
      var chain = Promise.resolve();
      lines().forEach(function (el) {
        var entry = state.lines[el.getAttribute('data-block-id')];
        if (entry) chain = chain.then(function () { return restoreLine(el, entry); });
      });
      chain.then(function () { return wait(100); }).then(function () { restoring = false; snapshot(); },
                                                            function () { restoring = false; });
    }

    var started = false;
    function start() {
      if (started || !document.querySelector('[data-product-kit-line]')) return;
      started = true;
      setTimeout(restoreAll, 50);
    }

    if (window.Alpine && document.querySelector('[data-product-kit-line]') &&
        document.querySelector('[data-product-kit-line]')._x_dataStack) {
      start();
    } else {
      document.addEventListener('alpine:initialized', start);
      window.addEventListener('load', function () { setTimeout(start, 300); });
    }

    // Save whenever the shopper changes something, and again on the way out.
    ['change', 'input', 'click'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        var t = event.target;
        if (t && t.closest && (t.closest('[data-product-kit-line]') || t.closest('[data-product-kit-summary]'))) scheduleSave();
      }, true);
    });
    document.addEventListener('cart:update', scheduleSave);
    window.addEventListener('pagehide', snapshot);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') snapshot();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-kit-line"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productKitLineFinishSync) return;
    window.__productKitLineFinishSync = true;

    /* ---------- Filename matching ----------
       The step product and the kit product are different products, so the
       same photo has a different media ID on each. We match on filename
       instead. "strict" only removes the CDN query string, extension and
       legacy size suffix; "loose" also removes the suffixes Shopify adds when
       the same file is uploaded twice (_1, _2 or _<uuid>). */
    function baseName(url) {
      if (!url) return '';
      var file = String(url).split('?')[0].split('#')[0];
      file = file.substring(file.lastIndexOf('/') + 1);
      try { file = decodeURIComponent(file); } catch (e) {}
      file = file.toLowerCase().replace(/\.(jpe?g|png|gif|webp|avif|heic)$/, '');
      file = file.replace(/_(\d+x\d*|x\d+)(@\dx)?$/, '');
      file = file.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master)$/, '');
      return file;
    }

    function strictKey(url) {
      return baseName(url);
    }

    function looseKey(url) {
      return baseName(url)
        .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/, '')
        .replace(/_\d{1,2}$/, '');
    }

    /* ---------- Main gallery helpers ---------- */
    function findGallery(line) {
      var section = line.closest('.shopify-section');
      return (section && section.querySelector('media-gallery')) || document.querySelector('media-gallery');
    }

    function getSlides(gallery) {
      var slides = gallery.querySelectorAll('slideshow-slide');
      if (!slides.length) slides = gallery.querySelectorAll('.product-media-container');
      return Array.prototype.slice.call(slides);
    }

    function slideUrls(slide) {
      var img = slide.querySelector('img');
      if (!img) return [];
      var urls = [img.getAttribute('src'), img.currentSrc];
      var srcset = img.getAttribute('srcset');
      if (srcset) urls.push(srcset.split(',')[0].trim().split(' ')[0]);
      return urls.filter(Boolean);
    }

    function findSlideIndex(slides, url, keyFn) {
      var target = keyFn(url);
      if (!target) return -1;
      for (var i = 0; i < slides.length; i++) {
        var urls = slideUrls(slides[i]);
        for (var j = 0; j < urls.length; j++) {
          if (keyFn(urls[j]) === target) return i;
        }
      }
      return -1;
    }

    function goToSlide(gallery, slides, index) {
      var slideshow = gallery.querySelector('slideshow-component');
      if (slideshow && typeof slideshow.select === 'function') {
        try {
          slideshow.select(index);
          return;
        } catch (e) {}
      }
      // Fallback: click the matching thumbnail if the slideshow API isn't there.
      var thumbs = gallery.querySelectorAll('slideshow-controls button');
      if (thumbs[index]) {
        thumbs[index].click();
        return;
      }
      // Grid layout (no slideshow): leave the page scroll alone.
    }

    /* ---------- Read the step's current image ---------- */
    function getLineImageUrl(line) {
      var img = null;
      var imgs = line.querySelectorAll('.product-kit-line__image');
      for (var i = 0; i < imgs.length; i++) {
        // Ignore images that belong to a nested kit line.
        if (imgs[i].closest('[data-product-kit-line]') === line) {
          img = imgs[i];
          break;
        }
      }
      var url = img ? img.getAttribute('src') : '';
      if (!url && window.Alpine && typeof window.Alpine.$data === 'function') {
        try { url = window.Alpine.$data(line).displayImageSrc || ''; } catch (e) {}
      }
      return url;
    }

    function syncGalleryFromLine(line) {
      var url = getLineImageUrl(line);
      if (!url) return;
      var gallery = findGallery(line);
      if (!gallery) return;
      var slides = getSlides(gallery);
      if (!slides.length) return;

      var index = findSlideIndex(slides, url, strictKey);
      if (index === -1) index = findSlideIndex(slides, url, looseKey);
      if (index === -1) return;

      goToSlide(gallery, slides, index);
    }

    /* ---------- Is the changed dropdown a "finish" option? ---------- */
    function isFinishSelect(select, line) {
      var label = select.closest('.product-kit-line__variant-label');
      var nameEl = label && label.querySelector('.product-kit-line__variant-name');
      var optionName = (nameEl ? nameEl.textContent : '').trim().toLowerCase();
      if (!optionName) return false;
      var names = (line.getAttribute('data-finish-option-names') || 'Finish')
        .toLowerCase()
        .split(',')
        .map(function (n) { return n.trim(); })
        .filter(Boolean);
      return names.some(function (n) { return optionName.indexOf(n) !== -1; });
    }

    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select || !select.matches || !select.matches('.product-kit-line__variant-select')) return;
      var line = select.closest('[data-product-kit-line]');
      if (!line || line.getAttribute('data-sync-gallery-finish') !== 'true') return;
      if (!isFinishSelect(select, line)) return;

      // Let Alpine finish updating the step image before reading it.
      setTimeout(function () { syncGalleryFromLine(line); }, 60);
    });
  })();

  /* ---------- Remember kit selections between visits ----------
     Saves each kit line's dropdowns, quantity and "in kit" state for this
     page in localStorage, and puts them back when the shopper returns.
     Restoring works by setting each dropdown and firing a normal change
     event, so the line's own code updates the price and the kit summary. */
  (function () {
    if (window.__productKitLineRemember) return;
    window.__productKitLineRemember = true;

    var STORAGE_KEY = 'kitState:' + location.pathname;
    var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // forget after 30 days
    var restoring = false;
    var saveTimer = null;

    function lines() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-product-kit-line][data-block-id]'));
    }

    function dataFor(el) {
      try { return window.Alpine && window.Alpine.$data(el); } catch (e) { return null; }
    }

    function load() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var state = JSON.parse(raw);
        if (!state || !state.lines || Date.now() - (state.savedAt || 0) > MAX_AGE_MS) return null;
        return state;
      } catch (e) { return null; }
    }

    function snapshot() {
      if (restoring) return;
      var out = { savedAt: Date.now(), lines: {} };
      lines().forEach(function (el) {
        var d = dataFor(el);
        var entry = { selects: {} };
        el.querySelectorAll('select.product-kit-line__variant-select[id]').forEach(function (select) {
          entry.selects[select.id] = select.value;
        });
        if (d) {
          if (typeof d.quantity === 'number') entry.qty = d.quantity;
          if (typeof d.selected === 'boolean') entry.selected = d.selected;
        }
        out.lines[el.getAttribute('data-block-id')] = entry;
      });
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(out)); } catch (e) {}
    }

    function scheduleSave() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(snapshot, 150);
    }

    function setSelect(select, value) {
      if (select.value === value) return false;
      var exists = Array.prototype.some.call(select.options, function (o) { return o.value === value; });
      if (!exists) return false;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    function restoreLine(el, entry) {
      var d = dataFor(el);
      if (!d || !entry) return Promise.resolve();

      // A ?variant= link to the main product wins over the saved choice.
      var urlHasVariant = /[?&]variant=/.test(location.search);
      var isMainProduct = el.getAttribute('data-product-id') && window.ShopifyAnalytics &&
        window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product &&
        String(window.ShopifyAnalytics.meta.product.id) === el.getAttribute('data-product-id');
      var skipSelects = urlHasVariant && isMainProduct;

      var selects = entry.selects || {};
      var productSelect = el.querySelector('select[id^="ProductKitLineProduct-"]');

      return Promise.resolve()
        .then(function () {
          // Product picker first, since it decides which option dropdowns apply.
          if (!skipSelects && productSelect && selects[productSelect.id] != null) {
            if (setSelect(productSelect, selects[productSelect.id])) return wait(60);
          }
        })
        .then(function () {
          if (skipSelects) return;
          var changed = false;
          el.querySelectorAll('select.product-kit-line__variant-select[id]').forEach(function (select) {
            if (select === productSelect) return;
            if (selects[select.id] != null && setSelect(select, selects[select.id])) changed = true;
          });
          if (changed) return wait(60);
        })
        .then(function () {
          if (typeof entry.qty === 'number' && entry.qty !== d.quantity) {
            var input = el.querySelector('.product-kit-line__quantity-input');
            var qty = Math.max(d.minQuantity || 1, Math.min(entry.qty, d.maxQuantity || entry.qty));
            if (input) {
              input.value = qty;
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              d.quantity = qty;
            }
          }
        })
        .then(function () {
          // Accessories that were in the kit go back in (no "Added" flash).
          // The kit summary and the line's price can take a moment to be
          // ready after the page loads, so keep checking for up to 3 seconds.
          if (typeof entry.selected !== 'boolean') return;
          var tries = 0;
          return new Promise(function (resolve) {
            (function attempt() {
              if (d.selected === entry.selected) return resolve();
              var atc = el.querySelector('.product-kit-line__atc');
              if (d.summaryMode && atc && !atc.disabled) {
                atc.click();
                clearTimeout(d.kitTimer);
                d.kitFlash = false;
                return resolve();
              }
              if (++tries >= 30) return resolve();
              setTimeout(attempt, 100);
            })();
          });
        });
    }

    function restoreAll() {
      var state = load();
      if (!state) return;
      restoring = true;
      var chain = Promise.resolve();
      lines().forEach(function (el) {
        var entry = state.lines[el.getAttribute('data-block-id')];
        if (entry) chain = chain.then(function () { return restoreLine(el, entry); });
      });
      chain.then(function () { return wait(100); }).then(function () { restoring = false; snapshot(); },
                                                            function () { restoring = false; });
    }

    var started = false;
    function start() {
      if (started || !document.querySelector('[data-product-kit-line]')) return;
      started = true;
      setTimeout(restoreAll, 50);
    }

    if (window.Alpine && document.querySelector('[data-product-kit-line]') &&
        document.querySelector('[data-product-kit-line]')._x_dataStack) {
      start();
    } else {
      document.addEventListener('alpine:initialized', start);
      window.addEventListener('load', function () { setTimeout(start, 300); });
    }

    // Save whenever the shopper changes something, and again on the way out.
    ['change', 'input', 'click'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        var t = event.target;
        if (t && t.closest && (t.closest('[data-product-kit-line]') || t.closest('[data-product-kit-summary]'))) scheduleSave();
      }, true);
    });
    document.addEventListener('cart:update', scheduleSave);
    window.addEventListener('pagehide', snapshot);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') snapshot();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
